var _rect, _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfJpg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    rx: 8,
    transform: "rotate(180 40 40)",
    fill: "#FECFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.7059C13 15.5447 13 13.9641 13.9958 12.9821C14.9917 12 16.5944 12 19.8 12H23.2C26.4056 12 28.0083 12 29.0042 12.9821C30 13.9641 30 15.5447 30 18.7059V24.2941C30 27.4553 30 29.0359 29.0042 30.0179C28.0083 31 26.4056 31 23.2 31H19.8C16.5944 31 14.9917 31 13.9958 30.0179C13 29.0359 13 27.4553 13 24.2941V18.7059Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1321,
    cy: 17.8769,
    r: 1.54737,
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.5565L14.475 21.4214C15.2424 20.8309 16.399 20.8648 17.12 21.4989L20.7324 24.6758C21.3111 25.1848 22.2221 25.2542 22.8917 24.8403L23.1428 24.6851C24.1064 24.0896 25.4101 24.1586 26.2854 24.8514L29 27",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 28C11.5222 28 10 26.4988 10 24.6471V17.9412C10 13.7263 10 11.6188 11.3278 10.3094C12.6556 9 14.7926 9 19.0667 9H23.6C25.4778 9 27 10.5012 27 12.3529",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfJpg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-jpg.6f79c9ec30ac25fa684d3d3d196615bb.svg";